import {Component, Input, OnInit} from '@angular/core';
import {BrowseConfig} from "@core/bean/browse-config";
import {Pagination} from "@core/bean/pagination";
import {InvoiceStrategyService} from "../../../../routes/jy-srm/basic-data/srm-invoice-strategy/invoice-strategy/invoice-strategy.service";
import {CommonsService} from "@core/service/commons.service";
import {Observable} from "rxjs/index";
import {HttpParams} from "@angular/common/http";

@Component({
  selector: 'app-invoice-methods',
  templateUrl: './invoice-methods.component.html',
  styles: []
})
export class InvoiceMethodsComponent implements OnInit {
  static componentName = 'InvoiceMethodsComponent';
  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;
  //列表查询
  pagination: Pagination = new Pagination();
  visible = false;
  address: any = {};
  rough:string;
  fine:string;
  searchData:any = {};
  constructor(private commonsService: CommonsService,private invoiceStrategyService:InvoiceStrategyService) {
    this.pagination.getData = function(params: HttpParams): Observable<any> {
      return invoiceStrategyService.query(params);
    };
  }

  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }


  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  doubleGet(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  reset() {
    this.searchData = {};
    this.pagination.searchData['strategyCode'] = null;
    this.pagination.searchData['strategyName'] = null;
  }
}
